import * as React from 'react';
import { cn } from '../lib/cn';

// docs/06: status pill = leading dot + text, never colour alone. Customer labels are sentence case; internal labels
// uppercase.
export type Tone = 'ok' | 'warn' | 'bad' | 'info' | 'neu';
const tones: Record<Tone, string> = {
  ok: 'bg-ok-bg text-ok', warn: 'bg-warn-bg text-warn', bad: 'bg-bad-bg text-bad', info: 'bg-info-bg text-info', neu: 'bg-neu-bg text-neu',
};

/** `title`: a short explanation shown on hover (and read by screen readers). */
export function Pill({ tone = 'neu', children, upper = false, className, title }: { tone?: Tone; children: React.ReactNode; upper?: boolean; className?: string; title?: string }) {
  return (
    <span title={title} className={cn('inline-flex items-center gap-1.5 whitespace-nowrap rounded-full px-2 py-0.5 text-xs font-semibold', tones[tone], upper && 'uppercase tracking-wide', className)}>
      <span className="size-1.5 rounded-full bg-current" aria-hidden />{children}
    </span>
  );
}
